import { trackGtmEvent } from './gtm-data-layer'

export const GTM = 'gtm'

export const GTM_EVENTS = {
  avantLinkPurchase: 'avantLinkPurchase',
  gtmEvent: 'gtmEvent',
  gtmEcomPromotionView: 'gtmEcomPromotionView',
  gtmEcomPromotionClick: 'gtmEcomPromotionClick',
  gtmEcomProductImpression: 'gtmEcomProductImpression',
  gtmEcomProductClick: 'gtmEcomProductClick',
  gtmEcomDetailView: 'gtmEcomDetailView',
  gtmEcomAddToCart: 'gtmEcomAddToCart',
  gtmEcomRemoveFromCart: 'gtmEcomRemoveFromCart',
  gtmEcomCheckout: 'gtmEcomCheckout',
  gtmEcomCheckoutOption: 'gtmEcomCheckoutOption',
  gtmEcomPurchase: 'gtmEcomPurchase',
  gtmVirtPath: 'gtmVirtPath',
  rockerBoxCheckout: 'rockerBoxCheckout',
  rockerBoxPurchase: 'rockerBoxPurchase',
}
const gtmEventHandlers = {}

Object.values(GTM_EVENTS).forEach(event => {
  gtmEventHandlers[event] = (event, eventPayload) => trackGtmEvent(event, eventPayload)
})

export default gtmEventHandlers
